// DO NOT EDIT -- generated from Go package fs/search/doc/fields/special

///////////////
// Constants //
///////////////

export const DefinedEventIdField: string = "$DefinedEventId";
export const NamedElementIdField: string = "$NamedElementId";
export const SpecObjectSlugField: string = "$SpecObjectSlug";
